import React, { createContext, useState, useContext } from 'react';
import PropTypes from 'prop-types';

import { useStore } from 'core/store';
import { isImportedAndNotEndorseable } from 'core/helpers/policy-status';

const DisableContext = createContext(true);

export const DisableProvider = ({ children, lockedByDrafting }) => {
  const {
    account: {
      policies: { policy: policyStore }
    }
  } = useStore();
  const policy = policyStore?.policy;
  const [disabled, setDisabled] = useState(false);
  const [activeForm, setActiveForm] = useState(null);
  const effectiveDisabled = disabled || isImportedAndNotEndorseable(policy) || lockedByDrafting;
  return (
    <DisableContext.Provider
      value={{ disabled: effectiveDisabled, lockedByDrafting, setDisabled, activeForm, setActiveForm }}
    >
      {children}
    </DisableContext.Provider>
  );
};

export const useDisabledState = () => {
  const { disabled, lockedByDrafting, setDisabled, activeForm, setActiveForm } = useContext(DisableContext);
  return { disabled, lockedByDrafting, setDisabled, activeForm, setActiveForm };
};

export const withDisabledState = (Component) => (props) => {
  const { disabled, setDisabled } = useContext(DisableContext);
  return <Component {...props} disabled={disabled} setDisabled={setDisabled} />;
};

DisableProvider.propTypes = {
  children: PropTypes.node.isRequired,
  lockedByDrafting: PropTypes.bool
};

DisableProvider.defaultProps = {
  lockedByDrafting: false
};
